import React from "react";
import styled from 'styled-components';

const PhotoStyle = styled.div`
    width: 80%;
    padding: 2rem;
    margin: auto;
    img {
        width: 100%;
        border-radius: 8px;
        display: block;
    }
    p {
        text-align: center;
        margin: 0;
    }
    @media screen and ( max-width : 600px ) {
        width: calc(100% - 1rem);
        padding: 2rem 0.5rem;  
    }
`;
const Photo =(props)=>{
    return(
            <PhotoStyle>
                <img src={props.data.url} alt='good' title={props.title} style={{backgroundColor:props.background}}/>
                <p style={{color:props.capcolor}}>{props.data.caption}</p>
            </PhotoStyle>
            )

}
export default Photo;